@if (
  type !== 'STRIPE_TWINT' &&
  type !== 'STRIPE_GOOGLE_PAY' &&
  type !== 'STRIPE_APPLE_PAY' &&
  type !== 'STRIPE_BANCONTACT'
) {
  <div class="relative mb-6">
    <label class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600">{{
      'payment.stripe.card-number' | translate
    }}</label>
    <div
      class="mb-6 flex h-12 w-full border border-solid border-neutral-300 bg-neutral-50 leading-5"
    >
      <div
        id="card-number-element"
        class="field"
      ></div>
    </div>
    <div class="mt-2 grid grid-cols-2 gap-2">
      <div>
        <label class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600">{{
          'payment.stripe.expiration-date' | translate
        }}</label>
        <div
          class="mb-6 flex h-12 w-full border border-solid border-neutral-300 bg-neutral-50 leading-5"
        >
          <div
            id="card-expiry-element"
            class="field"
          ></div>
        </div>
      </div>
      <div>
        <label class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600">{{
          'payment.stripe.security-code' | translate
        }}</label>
        <div
          class="mb-6 flex h-12 w-full border border-solid border-neutral-300 bg-neutral-50 leading-5"
        >
          <div
            id="card-cvc-element"
            class="field"
          ></div>
        </div>
      </div>
    </div>
    @if (isLoading) {
      <div class="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-white">
        <i class="icon icon-privacy animate-pulse text-4xl"></i>
      </div>
    }
  </div>
}

@if (type === 'STRIPE_BANCONTACT') {
  <div>
    <div class="mb-6 ml-3 flex-1">
      @if (user) {
        <div class="flex flex-row items-center justify-between">
          @if (!bancontact && user.firstname && user.lastname) {
            <div>
              <div class="flex items-center pb-2">
                <div class="text-neutral-800">
                  <h4 class="font-base font-bold">
                    {{ 'payment.bancontact.complete-name' | translate }}&#42;
                  </h4>
                  <p class="font-base">
                    {{ user.firstname | formatFullName: user.lastname }}
                  </p>
                </div>
              </div>
              <div class="flex items-center">
                @if (user.email) {
                  <div class="text-neutral-800">
                    <h4 class="font-base font-bold">
                      {{ 'payment.bancontact.email' | translate }}&#42;
                    </h4>
                    <p class="font-base">
                      {{ user.email }}
                    </p>
                  </div>
                }
              </div>
            </div>
          }
          @if (bancontact) {
            <div>
              <div class="flex items-center pb-2">
                @if (bancontact?.complete_name) {
                  <div class="text-neutral-800">
                    <h4 class="font-base font-bold">
                      {{ 'payment.bancontact.complete-name' | translate }}&#42;
                    </h4>
                    <p class="font-base">
                      {{ bancontact?.complete_name }}
                    </p>
                  </div>
                }
              </div>
              <div class="flex items-center">
                @if (bancontact.email) {
                  <div class="text-neutral-800">
                    <h4 class="font-base font-bold">
                      {{ 'payment.bancontact.email' | translate }}&#42;
                    </h4>
                    <p class="font-base">
                      {{ bancontact.email }}
                    </p>
                  </div>
                }
              </div>
            </div>
          }
          @if (!bancontact.email && !user.email) {
            <div class="font-base text-neutral-800">
              {{ 'payment.bancontact.description' | translate }}
            </div>
          }
          @if (
            (user[userKeys.FirstName] && user[userKeys.LastName] && user[userKeys.Email]) ||
            (!user[userKeys.Email] && bancontact.email)
          ) {
            <app-button-atom
              size="XS"
              thickSize="XS"
              [label]="'payment.bancontact.modify' | translate"
              type="light"
              (click)="openBancontactForm()"
            ></app-button-atom>
          }
          @if (!bancontact.email && !user.email) {
            <app-button-atom
              size="XS"
              thickSize="XS"
              [label]="'payment.bancontact.add' | translate"
              type="primary"
              (click)="openBancontactForm()"
            ></app-button-atom>
          }
        </div>
      }
    </div>
  </div>
}

@if ((type === 'STRIPE_GOOGLE_PAY' || type === 'STRIPE_APPLE_PAY') && paymentRequestOptions) {
  <div class="relative mb-6">
    <ngx-stripe-payment-request-button
      [paymentOptions]="paymentRequestOptions"
      (paymentMethod)="onPaymentMethod($event)"
      (notavailable)="onNotAvailable()"
    ></ngx-stripe-payment-request-button>
  </div>
}
